import { Trans, useTranslation } from 'react-i18next';

import { looseListT } from '@/i18n/looseT';

import { PublicDocLayout } from './PublicDocLayout';
import { useDocumentTitle } from './useDocumentTitle';

/**
 * `/disclaimer` — HAi Creative 免責聲明(公開頁,不包 `RequireAuth`)
 * -----------------------------------------------------------------------------
 * 路徑對齊 mentor(`mentor-login.haitech.com.tw/disclaimer`),owner 2026-09-11 指定。
 * 文案逐字來自 owner 交付的免責聲明稿(2026-09-14 改版,九條),**不改寫**。
 *
 * 🔴 **owner 2026-09-14/15 拍板:法務的文字一字一句、包含標點符號都不能改。**
 * 所以標點是**全形**(跟 `site.json` 其他段落的半形刻意不一致)、第 3 條的引號是單引號
 * `『可為商業使用』`(全文其餘都是「」)。已知且刻意留著的用語不一致:第 3 條寫「本服務條款」
 * 而第 1 條定義的簡稱是「服務條款」、第 7 條同一句並用「訂閱服務合約」與「訂閱合約」、
 * 第 1 條引《HAi Creative 服務條款》而條款實際文件名是《…與隱私權保護政策》。
 * **不要順手統一** —— 有機械閘擋著(`siteCompleteness.test` 的「法務文字一字一句…」那條)。
 *
 * ⚠️ 條款各自含 `<b>` 強調,所以走 `<Trans>` 而不是 `t()` —— 直接把含標籤的字串
 * 塞進 JSX 會原樣顯示 `<b>`。JSON 裡保留 `<b>` 對翻譯的人也是常見寫法。
 *
 * ⚠️ **條數不寫死在這裡**:`disclaimer.clauses` 是陣列,條數由 JSON 決定
 * (`siteCompleteness.test` 鎖三語等長)。條號由 CSS counter 畫(`ol.clauses`),
 * 所以 JSON 的**順序就是條號** —— 中間插一條會把後面全部推一號。
 */
export function DisclaimerPage() {
  const { t } = useTranslation('site');
  const list = looseListT(t);
  useDocumentTitle(t('disclaimer.docTitle'));
  return (
    <PublicDocLayout
      scope="hai-site--disclaimer"
      pageLabel={t('disclaimer.barPage')}
      title={t('disclaimer.title')}
      updatedDate={t('disclaimer.updatedDate')}
      footerSecondary={{ to: '/user-terms', label: t('docFooter.terms') }}
    >
      <ol className="clauses" data-testid="disclaimer-clauses">
        {list('disclaimer.clauses').map((_, i) => (
          <li key={i}>
            <Trans t={t} i18nKey={`disclaimer.clauses.${i}`} components={{ b: <b /> }} />
          </li>
        ))}
      </ol>
    </PublicDocLayout>
  );
}
